import request from '@/utils/request';

/**
 * @description 新增商户装修模板
 */
export function pagediySaveApi(data) {
  return request({
    url: '/admin/merchant/page/diy/save',
    method: 'post',
    data: data
  });
}

/**
 * @description 商户装修模板分页列表
 */
export function pagediyListApi(params) {
  return request({
    url: '/admin/merchant/page/diy/page',
    method: 'get',
    params: params
  });
}

/**
 * @description diy 详情
 */
export function pagediyInfoApi(id) {
  return request({
    url: "/admin/merchant/page/diy/info/".concat(id),
    method: 'get'
  });
}

/**
 * @description 编辑商户装修模板
 */
export function pagediyUpdateApi(data) {
  return request({
    url: "/admin/merchant/page/diy/update",
    method: 'post',
    data: data
  });
}

/**
 * @description 设置商户装修默认首页
 */
export function pagediySetdefaultApi(id) {
  return request({
    url: "/admin/merchant/page/diy/set/default/".concat(id),
    method: 'post'
  });
}

/**
 * @description 删除商户装修模板
 */
export function pagediyDeleteApi(params) {
  return request({
    url: "/admin/merchant/page/diy/delete/".concat(params),
    method: 'post'
  });
}

/**
 * 获取商户装修默认首页ID
 * @returns {*}
 */
export function pagediyGetSetHome() {
  return request({
    url: "/admin/merchant/page/diy/get/default/id",
    method: 'get'
  });
}

/**
 * 获取小程序二维码
 * @returns {*}
 */
export function wechatQrcodeApi(data) {
  return request({
    url: "/publicly/wechat/mini/get/qrcode",
    method: 'post',
    data: data
  });
}

/**
 * 编辑商户装修模板名称
 * @returns {*}
 */
export function pagediyUpdatenameApi(data) {
  return request({
    url: "/admin/merchant/page/diy/update/name",
    method: 'post',
    data: data
  });
}

/**
 * 获取开屏广告配置
 * @returns {*}
 */
export function splashGetApi() {
  return request({
    url: "/admin/platform/page/layout/splash/ad/get",
    method: 'get'
  });
}

/**
 * 编辑开屏广告配置
 * @returns {*}
 */
export function splashSaveApi(data) {
  return request({
    url: "/admin/platform/page/layout/splash/ad/save",
    method: 'post',
    data: data
  });
}

/**
 * @description 区域管理diy 新增
 */
export function pagediyAreasSaveApi(data) {
  return request({
    url: '/admin/platform/page/diy/circle/save',
    method: 'post',
    data: data
  });
}

/**
 * @description 区域管理diy 详情
 */
export function pagediyAreasInfoApi(id) {
  return request({
    url: "/admin/platform/page/diy/circle/info/".concat(id),
    method: 'get'
  });
}

/**
 * @description 区域管理diy 修改
 */
export function pagediyAreasUpdateApi(data) {
  return request({
    url: "/admin/platform/page/diy/circle/update",
    method: 'post',
    data: data
  });
}

/**
 * @description 区域管理diy 设置区域管理首页
 */
export function pagediyAreasSetAreasdefaultApi(id) {
  return request({
    url: "/admin/platform/page/diy/circle/set/circle/default/".concat(id),
    method: 'post'
  });
}

/**
 * @description 区域管理diy 删除
 */
export function pagediyAreasDeleteApi(id) {
  return request({
    url: "/admin/platform/page/diy/circle/delete/".concat(id),
    method: 'post'
  });
}

/**
 * @description 获取区域DIY模板默认商城首页ID
 */
export function pagediyAreasSetDefaultApi(id) {
  return request({
    url: "/admin/platform/page/diy/circle/set/default/".concat(id),
    method: 'post'
  });
}

/** 商户模板市场列表 */
export function pagediyTemplateListApi(params) {
  return request({
    url: '/admin/merchant/page/diy/template/page',
    method: 'get',
    params: params
  });
}

/** 永久套用商户模板 */
export function pagediyTemplateUseApi(id) {
  return request({
    url: "/admin/merchant/page/diy/template/use/".concat(id),
    method: 'post'
  });
}